/**
 * Whether the QA simulate-failure switch is switched ON for this page load.
 *
 * Set once by `simulateFailureInterceptor` after it has read
 * `RuntimeConfig.simulateFailureEnabled`. It exists because `fetchSchemaAsset`
 * is a plain function with no injection context, so it cannot read the runtime
 * config itself. The interceptor runs on the first API call (the session check),
 * which always precedes any sheet's schema load.
 *
 * Deliberately tiny and referenced only by the swapped feature files, so the
 * production build (which swaps those for stubs) does not ship it.
 */
let simulationEnabled = false;

export function markSimulationEnabled(): void {
  simulationEnabled = true;
}

export function isSimulationEnabled(): boolean {
  return simulationEnabled;
}

/** For specs only: this flag is module-level, so a spec that turns it on must turn it off again. */
export function resetSimulationEnabledForTests(): void {
  simulationEnabled = false;
}
